// scroll 滚动插件的公共配置
export default function classOption() {
  return {
    step: 0.6,
    hoverStop: true,
    direction: 0,
  };
}
